module.exports = __webpack_public_path__ + "static/chicken-floss-4b21fcb2a7586c37f15f198966668fb1.jpg";